import React, { useState, Dispatch, SetStateAction, useEffect } from "react";
import {
  StyledCol,
  StyledTypography,
  DropDownContent
} from "../multiLevelDropDown.style";
import ArrowRightRounded from "@mui/icons-material/ArrowRightRounded";
import ArrowDropDownRounded from "@mui/icons-material/ArrowDropDownRounded";
import { StyledDropDown } from "../multiLevelDropDown.style";
import { MenuItem } from "component/layoutComponents/topNav/topNav.types";
import { createPseudoStyleFromMuiIcon } from "utils/functions";

interface IMenuItemsProps {
  items: MenuItem;
  depthLevel: number;
  active?: string;
  onMultiLevelMenuClick: (item: MenuItem) => void;
  location: any;
  setExpanded: Dispatch<SetStateAction<string>>;
}

interface IDropDownProps {
  subMenus: MenuItem[];
  dropDown: boolean;
  depthLevel: number;
  onMultiLevelMenuClick: (item: MenuItem) => void;
  location: any;
  setExpanded: Dispatch<SetStateAction<string>>;
}

const DropDown: React.FC<IDropDownProps> = (props) => {
  const { subMenus, dropDown, onMultiLevelMenuClick, location, setExpanded } = props;
  let { depthLevel } = props;
  depthLevel = depthLevel + 1;
  const dropdownClass = depthLevel > 1 ? "dropdown-submenu" : "";

  return (
    <StyledDropDown component="ul" className={`${dropdownClass} ${dropDown ? "show" : ""}`}>
      {subMenus?.map((submenu: any, index: any) => (
        <MenuItems setExpanded={setExpanded} onMultiLevelMenuClick={onMultiLevelMenuClick} key={index} items={submenu} depthLevel={depthLevel} location={location}/>
      ))}
    </StyledDropDown>
  );
};

const MenuItems: React.FC<IMenuItemsProps> = (props) => {
  const { items, depthLevel, active = '', onMultiLevelMenuClick, location, setExpanded } = props;
  const [dropdown, setDropdown] = useState(false);

  useEffect(() => {
    setDropdown(false);
  }, [location]);

  const handleMenuClick = (e:any,item: any) => {
    e.preventDefault();
    onMultiLevelMenuClick(item);
    e.stopPropagation();
    setExpanded("");
  }

  const enterKeyPress = (e: { keyCode: any;}, item: any) => {
    if (e.keyCode === 13) {
      handleMenuClick(e,item);
    }
  };

  const typographyClassName = `${active === items.key && depthLevel === 0 && `active`} ${dropdown && `focus`}`;
  const hasSubMenu = items.items && items.items.length > 0;
  const icon = hasSubMenu ? depthLevel > 0 ? <ArrowRightRounded /> : <ArrowDropDownRounded /> : null;

  return (
    <DropDownContent
      onMouseEnter={() => setDropdown(true)}
      onMouseLeave={() => setDropdown(false)}
    >
      <StyledCol level={depthLevel}>
        <StyledTypography
          href={items.url || '#'}
          tabIndex={0}
          onKeyDown={(e) => enterKeyPress(e, items)}
          level={hasSubMenu ? depthLevel : 0}
          className={typographyClassName}
          onClick={(e) => handleMenuClick(e, items)}
          pseudoStyle={createPseudoStyleFromMuiIcon(icon)}
        >
          {items.name}
        </StyledTypography>
        {hasSubMenu && (
          <DropDown
            depthLevel={depthLevel}
            subMenus={items.items || []}
            dropDown={dropdown}
            onMultiLevelMenuClick={onMultiLevelMenuClick}
            location={location}
            setExpanded={setExpanded}
          />
        )}
      </StyledCol>
    </DropDownContent>
  );
};

export default MenuItems;
